import { Helpers } from '../../helpers';
import { IRig } from '../../interfaces/irig';
import { AreaTeam } from '../area-team';
import { AssetTeam } from '../asset-team';
import { DirectionalServiceCompany } from '../directional-service-company';
import { DrillGroup } from '../drill-group';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { Rig } from '../rig';
import { RigAvailability } from '../rig-availability';
import { RigContract } from '../rig-contract';
import { RigCost } from '../rig-cost';
import { RigHistory } from '../rig-history';
import { RigRate } from '../rig-rate';
import { RigRateDetail } from '../rig-rate-detail';
import { RigRateRange } from '../rig-rate-range';
import { RigType } from '../rig-type';
import { Scenario } from '../scenario';
import { ScenarioWell } from '../scenario-well';
import { ScheduleActivity } from '../schedule-activity';
import { WaterWell } from '../water-well';

export class RigBase {
  RigId: number;
  AssetTeamId: number;
  ScenarioId: number | null;
  ParentRigId: number | null;
  DirectionalServiceCompanyId: number | null;
  Name: string;
  Alias: string;
  P6Identifier: string | null;
  IsActive: boolean;
  IsSpudderRig: boolean;
  IsRotarySteerable: boolean;
  MaxWellsPerPad: number | null;
  MaxLateralLength: number | null;
  FootPerDay: number | null;
  IsToBeDetermined: boolean;
  Horsepower: number | null;
  AreaTeamId: number | null;
  IsRigRamp: boolean | null;
  RigTypeId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  SysStartTime: Date;
  SysEndTime: Date;

  DrillGroups_Rig?: Array<DrillGroup> | null;
  ProjectDrillingParameters_Rig?: Array<ProjectDrillingParameter> | null;
  RigAvailabilities_Rig?: Array<RigAvailability> | null;
  RigContracts_Rig?: Array<RigContract> | null;
  RigCosts_Rig?: Array<RigCost> | null;
  RigHistory_Rig?: Array<RigHistory> | null;
  RigRateDetails_Rig?: Array<RigRateDetail> | null;
  RigRateRanges_Rig?: Array<RigRateRange> | null;
  RigRates_Rig?: Array<RigRate> | null;
  ScheduleActivities_Rig?: Array<ScheduleActivity> | null;
  WaterWells_Rig?: Array<WaterWell> | null;
  Rigs_ParentRig?: Array<Rig> | null;
  ScenarioWells_SpudderRig?: Array<ScenarioWell> | null;
  AreaTeam?: AreaTeam;
  AssetTeam?: AssetTeam;
  DirectionalServiceCompany?: DirectionalServiceCompany;
  RigType?: RigType;
  Scenario?: Scenario;
  ParentRig?: Rig;

  constructor(item?: IRig) {
    if (item) {

      this.RigId = item.RigId;
      this.AssetTeamId = item.AssetTeamId;
      this.ScenarioId = item.ScenarioId;
      this.ParentRigId = item.ParentRigId;
      this.DirectionalServiceCompanyId = item.DirectionalServiceCompanyId;
      this.Name = item.Name;
      this.Alias = item.Alias;
      this.P6Identifier = item.P6Identifier;
      this.IsActive = item.IsActive;
      this.IsSpudderRig = item.IsSpudderRig;
      this.IsRotarySteerable = item.IsRotarySteerable;
      this.MaxWellsPerPad = item.MaxWellsPerPad;
      this.MaxLateralLength = item.MaxLateralLength;
      this.FootPerDay = item.FootPerDay;
      this.IsToBeDetermined = item.IsToBeDetermined;
      this.Horsepower = item.Horsepower;
      this.AreaTeamId = item.AreaTeamId;
      this.IsRigRamp = item.IsRigRamp;
      this.RigTypeId = item.RigTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;

      this.DrillGroups_Rig = Helpers.createClassArray(DrillGroup, item.DrillGroups_Rig);
      this.ProjectDrillingParameters_Rig = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_Rig);
      this.RigAvailabilities_Rig = Helpers.createClassArray(RigAvailability, item.RigAvailabilities_Rig);
      this.RigContracts_Rig = Helpers.createClassArray(RigContract, item.RigContracts_Rig);
      this.RigCosts_Rig = Helpers.createClassArray(RigCost, item.RigCosts_Rig);
      this.RigHistory_Rig = Helpers.createClassArray(RigHistory, item.RigHistory_Rig);
      this.RigRateDetails_Rig = Helpers.createClassArray(RigRateDetail, item.RigRateDetails_Rig);
      this.RigRateRanges_Rig = Helpers.createClassArray(RigRateRange, item.RigRateRanges_Rig);
      this.RigRates_Rig = Helpers.createClassArray(RigRate, item.RigRates_Rig);
      this.ScheduleActivities_Rig = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_Rig);
      this.WaterWells_Rig = Helpers.createClassArray(WaterWell, item.WaterWells_Rig);
      this.Rigs_ParentRig = Helpers.createClassArray(Rig, item.Rigs_ParentRig);
      this.ScenarioWells_SpudderRig = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_SpudderRig);
      this.AreaTeam = new AreaTeam(item.AreaTeam);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.DirectionalServiceCompany = new DirectionalServiceCompany(item.DirectionalServiceCompany);
      this.RigType = new RigType(item.RigType);
      this.Scenario = new Scenario(item.Scenario);
      this.ParentRig = new Rig(item.ParentRig);
    }
  }
}